import fileNotFound_img from './404.png';

function NotFound(){
    return(
        <div className='divFlexSpan'>
            <img src={fileNotFound_img} alt="404"></img>
        </div>
    );
}
export default NotFound;